module.exports = __webpack_public_path__ + "static/media/Department.0bee1fc0.svg";